import React from "react";

interface CheckboxProps {
  inputId?: string;
  inputName: string;
  checked?: boolean;
  inputValue?: string;
  inputClassName?: string;
  labelFor: string;
  labelClassName?: string;
  labelTitle: string;
  onChange?: () => void;
}
const Checkbox: React.FC<CheckboxProps> = ({
  inputId,
  inputName,
  checked,
  inputClassName,
  labelFor,
  inputValue,
  labelClassName,
  labelTitle,
  onChange,
}) => {
  return (
    <span className="flex items-center gap-2">
      <input
        onChange={onChange}
        type="checkbox"
        id={inputId}
        name={inputName}
        checked={checked}
        className={
          "h-4 w-4 text-primary focus:ring-primary  rounded accent-primary border-primary-border border-solid border cursor-pointer " +
          inputClassName
        }
      />
      <label
        htmlFor={labelFor}
        className={
          "break-words text-text-secondary font-medium text-sm cursor-pointer " + labelClassName
        }
      >
        {labelTitle}
      </label>
    </span>
  );
};

export default Checkbox;
